module.exports = __webpack_public_path__ + "static/media/video.28aef320.webm";